import { formatCurrency, getCurrencyFormat, getCurrencySymbol } from './currency.js';
const DEFAULT_FRACTION = 2;
export const formatPrice = (price, { useGrouping = true, currency = 'USD', format, fraction, convertDust = true, minFraction = 0, } = {}) => {
    const priceNumber = parseFloat(price.toString());
    let fractionDigits = fraction;
    if (fractionDigits === undefined) {
        fractionDigits = priceNumber === 0 ? 0 : DEFAULT_FRACTION;
    }
    const currencySymbol = getCurrencySymbol(currency);
    const currencyFormat = format || getCurrencyFormat(currency);
    const isDust = priceNumber < Math.pow(10, -fractionDigits) && priceNumber > 0;
    if (convertDust && isDust) {
        return formatCurrency(0, {
            minFraction: 0,
            maxFraction: 0,
            format: currencyFormat,
            symbol: currencySymbol,
            useGrouping,
        });
    }
    return formatCurrency(price, {
        minFraction,
        maxFraction: fractionDigits,
        format: currencyFormat,
        symbol: currencySymbol,
        useGrouping,
    });
};
export function formatPriceOld(price, fixed = true, useGrouping = true, currency = 'USD') {
    const priceNumber = Number(price);
    if (priceNumber === 0) {
        return formatCurrency(0, {
            minFraction: 0,
            maxFraction: 0,
            format: getCurrencyFormat(currency),
            symbol: getCurrencySymbol(currency),
            useGrouping,
        });
    }
    const isDust = priceNumber < 0.01 && priceNumber > 0;
    if (isDust) {
        return `${formatCurrency(0, {
            minFraction: 0,
            maxFraction: 0,
            format: getCurrencyFormat(currency),
            symbol: getCurrencySymbol(currency),
            useGrouping,
        })}`;
    }
    return formatCurrency(price, {
        minFraction: 0,
        maxFraction: 2,
        format: getCurrencyFormat(currency),
        symbol: getCurrencySymbol(currency),
        useGrouping,
    });
}
export function formatPriceUSD(price) {
    return formatPrice(price);
}
export function formatAssetPrice({ price, currency, decimals: decimalsFromProps, }) {
    return formatPrice(price.toString(), {
        currency,
        fraction: decimalsFromProps || getFiatAdaptiveFraction(price),
        convertDust: true,
        useGrouping: true,
    });
}
export const getFiatAdaptiveFraction = (price) => {
    price = Number(price);
    return price === 0 ? 2 : price >= 1 ? 2 : price >= 0.0001 ? 4 : 6;
};
